/**
 * @see https://github.com/riktenx/loot-filters/blob/bec89ccfee8f85fab8c8b1dc9da49f972c2316fb/src/main/java/com/lootfilters/rule/FontType.java#L15
 */
export var TextAccent = {
    Shadow: 1,
    Outline: 2,
    None: 3,
    ShadowBold: 4,
};
export var textAccents = Object.values(TextAccent);
export var labelFromTextAccent = function (textAccent) {
    switch (textAccent) {
        case TextAccent.Shadow:
            return 'Shadow';
        case TextAccent.Outline:
            return 'Outline';
        case TextAccent.None:
            return 'None';
        case TextAccent.ShadowBold:
            return 'Bold Shadow';
    }
};
export var fontFamilyFromFontType = function (fontType) {
    switch (fontType) {
        case 1:
            return 'RuneScapeSmall';
        case 2:
            return 'RuneScape';
        case 3:
            return 'RuneScapeBold';
        default:
            return 'RuneScapeSmall';
    }
};
/**
 * @see https://github.com/riktenx/loot-filters/blob/bec89ccfee8f85fab8c8b1dc9da49f972c2316fb/src/main/java/com/lootfilters/rule/FontType.java#L15

 */
export var FontType = {
    Small: 1,
    Normal: 2,
    Bold: 3,
};
export var fontTypes = Object.values(FontType);
export var labelFromFontType = function (fontType) {
    switch (fontType) {
        case FontType.Small:
            return 'Small';
        case FontType.Normal:
            return 'Normal';
        case FontType.Bold:
            return 'Bold';
    }
};
